"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Button = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Button"));
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
var _classnames = _interopRequireDefault(require("classnames"));
var CloseIcon = function CloseIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M4.293 4.293a1 1 0 0 1 1.414 0L12 10.586l6.293-6.293a1 1 0 1 1 1.414 1.414L13.414 12l6.293 6.293a1 1 0 0 1-1.414 1.414L12 13.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L10.586 12 4.293 5.707a1 1 0 0 1 0-1.414z"
  }));
};
CloseIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var styles = {
  "button": "EditActions__button__3E8ym",
  "edit-button": "EditActions__edit-button__1k-uG",
  "editButton": "EditActions__edit-button__1k-uG",
  "icon": "EditActions__icon__3YwIl"
}; 
require('../EditActions.css');
var CloseButton = function CloseButton(_ref) {
  var _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
    onClick = _ref.onClick;
  return /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: "button",
    testId: "asset-metadata-close-button-id",
    onClick: onClick,
    disabled: isDisabled,
    "aria-describedby": "asset-metadata-close-button",
    "aria-label": "Close Button",
    className: (0, _classnames.default)(styles.button, styles.editButton),
    size: "md",
    kind: null,
    noFill: true
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    className: styles.icon
  }, /*#__PURE__*/_react.default.createElement(CloseIcon, null)), /*#__PURE__*/_react.default.createElement("span", {
    id: "asset-metadata-close-button",
    className: "visually-hidden"
  }, "Exit edit mode in minor version properties"));
};
var _default = exports.default = CloseButton;
//# sourceMappingURL=CloseButton.js.map